'use client'

import type { PropsWithChildren, ReactNode } from 'react'

import type { TextSize, ThemeTextColor } from '@mntn-dev/ui-theme'
import { Text } from '../../text/text.tsx'
import { usePageHeaderContext } from './use-page-header.ts'
import type { PageHeaderSize } from './use-page-header.ts'

const fontSizeMap: Record<PageHeaderSize, TextSize> = {
  sm: 'sm',
  md: 'base',
  lg: 'base',
}

export const PageHeaderSubtitle = ({
  subtitle,
  textColor = 'secondary',
}: PropsWithChildren<{ subtitle: ReactNode; textColor?: ThemeTextColor }>) => {
  const { dataTestId, dataTrackingId, size } = usePageHeaderContext()
  return (
    <div className="flex gap-4">
      <Text
        textColor={textColor}
        fontSize={fontSizeMap[size]}
        dataTestId={`${dataTestId}-subtitle`}
        dataTrackingId={`${dataTrackingId}-subtitle`}
      >
        {subtitle}
      </Text>
    </div>
  )
}
